import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import UsersComponent from '../components/UsersComponent';
import HeaderComponent from '../components/HeaderComponent';

class UsersPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <UsersComponent location={this.props.location}/>
            </div>
        );
    }
}

export default UsersPage;